import { SearchExistingField } from '@skyline-platform/alchemy';
import { getZones } from '@utils/graphql/creators/zones';
import PropTypes from 'prop-types';
import { ZoneForm } from '@components/FormComponents/ZoneForm/ZoneForm';
import { useState } from 'react';
import { getLogger } from '@utils/general';
const logger = getLogger('src.components.FormComponents.ZoneForm.SearchExistingZone');

export const SearchExistingZone = ({ ...props }) => {
  const { formData, setFormData } = { ...props };
  const [newCreatedZone, setNewCreatedZone] = useState(() => formData || {});

  const getAvailableZones = async () => {
    const { query, execute } = getZones();
    query.addReturnProperties('name', 'id');

    try {
      const res = await execute();
      return res;
    } catch (error) {
      logger.error(error.message);
    }
  };

  return (
    <SearchExistingField
      fieldName='Zone'
      required
      fetchData={getAvailableZones}
      {...props}
      newlyCreatedItem={newCreatedZone}
      newFieldForm={(handleClose) => (
        <ZoneForm
          handleClose={handleClose}
          setSourceData={setFormData}
          setNewCreatedZone={setNewCreatedZone}
        />
      )}
    />
  );
};

SearchExistingZone.propTypes = {
  formData: PropTypes.shape({
    zone: PropTypes.string,
  }).isRequired,
  setFormData: PropTypes.func.isRequired,
};
